import logger from "../logger";

/** Strips out any query params to determine the canonical URL */
export const getCanonicalClientUrl = (url: string) => {
  try {
    const { origin, pathname } = new URL(url);
    return origin + pathname;
  } catch (error) {
    logger.error("Failed to get canonical client url", {
      message: error.message,
    });
    return url;
  }
};
